// extracted by mini-css-extract-plugin
export default {"editArticle":"styles_editArticle__RgbMj","container":"styles_container__MZi-7","closeButton":"styles_closeButton__U0MMF","content":"styles_content__OZQ09"};